import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.tooltips = {}
    this.applyBound = this.apply.bind(this)
    document.addEventListener("turbo:frame-load", this.applyBound)
    this.apply()
  }

  disconnect() {
    if (this.applyBound) document.removeEventListener("turbo:frame-load", this.applyBound)
    this.fetched = false
  }

  apply() {
    if (!document.querySelector("[data-ai-tooltip-key]:not([data-tippy])")) return

    if (!this.fetched) {
      this.fetched = true
      this.fetchTooltips()
      return
    }

    let changed = false
    document.querySelectorAll("[data-ai-tooltip-key]:not([data-tippy])").forEach((el) => {
      const content = this.tooltips[el.dataset.aiTooltipKey]
      if (!content) return
      el.setAttribute("data-tippy", content)
      el.setAttribute("data-tippy-allow-html", "true")
      changed = true
    })
    if (changed) document.dispatchEvent(new CustomEvent("app.tippy.refresh"))
  }

  async fetchTooltips() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      this.tooltips = await res.json()
      this.apply()
    } catch (_) { /* tooltips are non-critical */ }
  }
}
